import * as React from "react";
import {Route, Switch} from "react-router-dom";
import ActiveInsurances from "InsuranceV2/ActiveInsurances";
import LandingPage from "InsuranceV2/LandingPage";
import {IInsuranceDetails} from "InsuranceV2/index";
import ExitPage from "InsuranceV2/ExitPage";

export enum routePaths {
    ACTIVE_INSURANCE = "active-insurance",
    EXIT = "exit"
}

export function getInsuranceRoutes(path: string, insuranceDetails: IInsuranceDetails) {
    return (
        <Switch>
            <Route exact path={path} render={(props) => <LandingPage {...props}
              link={insuranceDetails.link} insuranceList={insuranceDetails.active}/>}/>
            <Route exact path={`${path}/${routePaths.ACTIVE_INSURANCE}`}
                   render={(props) => <ActiveInsurances {...props} insuranceList={insuranceDetails.active}/>}
            />
            <Route exact path={`${path}/${routePaths.EXIT}`} component={ExitPage} />
        </Switch>
    );
}
